import React from "react";
import {
  Table,
  Label,
  Segment,
  Button,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import { Grids, commonLabels } from "../../../../redux/constants/Values";

export const LCData = (props) => {
  const {
    detailsPageButtonIsClicked,
    lcDataDetailsData,
    isFetchingLCData,
  } = props;
  return (
    <>
      <Segment padded>
        <Label attached="top" size="big" className="bgBlue">
          {Grids.lc + " " + commonLabels.data}
          <Button
            primary
            onClick={detailsPageButtonIsClicked.bind(this, Grids.lc)}
            floated="right"
          >
            {commonLabels.viewAll}
          </Button>
        </Label>
        <Table
          className="displayTable"
          singleLine
          compact
          striped
          sortable
          celled
          textAlign="center"
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Display Name</Table.HeaderCell>
              <Table.HeaderCell>Value</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {isFetchingLCData ? (
            <Dimmer active inverted>
              <Loader size="mini">{commonLabels.fetching}</Loader>
            </Dimmer>
          ) : (
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  {lcDataDetailsData &&
                  lcDataDetailsData.length > 0 &&
                  lcDataDetailsData[0].mnemonicDisplayName !== "N/A"
                    ? lcDataDetailsData[0].mnemonicDisplayName
                    : lcDataDetailsData && lcDataDetailsData.length > 0
                    ? lcDataDetailsData[0].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {lcDataDetailsData &&
                    lcDataDetailsData.length > 0 &&
                    lcDataDetailsData[0].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {lcDataDetailsData &&
                  lcDataDetailsData.length > 1 &&
                  lcDataDetailsData[1].mnemonicDisplayName !== "N/A"
                    ? lcDataDetailsData[1].mnemonicDisplayName
                    : lcDataDetailsData && lcDataDetailsData.length > 1
                    ? lcDataDetailsData[1].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {lcDataDetailsData &&
                    lcDataDetailsData.length > 1 &&
                    lcDataDetailsData[1].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {lcDataDetailsData &&
                  lcDataDetailsData.length > 2 &&
                  lcDataDetailsData[2].mnemonicDisplayName !== "N/A"
                    ? lcDataDetailsData[2].mnemonicDisplayName
                    : lcDataDetailsData && lcDataDetailsData.length > 2
                    ? lcDataDetailsData[2].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {lcDataDetailsData &&
                    lcDataDetailsData.length > 2 &&
                    lcDataDetailsData[2].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {lcDataDetailsData &&
                  lcDataDetailsData.length > 3 &&
                  lcDataDetailsData[3].mnemonicDisplayName !== "N/A"
                    ? lcDataDetailsData[3].mnemonicDisplayName
                    : lcDataDetailsData && lcDataDetailsData.length > 3
                    ? lcDataDetailsData[3].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {lcDataDetailsData &&
                    lcDataDetailsData.length > 3 &&
                    lcDataDetailsData[3].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {lcDataDetailsData &&
                  lcDataDetailsData.length > 4 &&
                  lcDataDetailsData[4].mnemonicDisplayName !== "N/A"
                    ? lcDataDetailsData[4].mnemonicDisplayName
                    : lcDataDetailsData && lcDataDetailsData.length > 4
                    ? lcDataDetailsData[4].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {lcDataDetailsData &&
                    lcDataDetailsData.length > 4 &&
                    lcDataDetailsData[4].mnemonicValue}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          )}
        </Table>
      </Segment>
    </>
  );
};

export default LCData;
